export function validateInteger(rule, value, callback) {
  // 允许空值
  const reg = /^[+]{0,1}(\d+)$/;
  if (reg.test(value) || value === '' || value === undefined || value === null) {
    callback();
  } else {
    return callback(new Error('请输入正整数'));
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js